import styled from 'styled-components';
import ShieldIcon from 'js/components/core/Icons/ShieldIcon';

export default styled(ShieldIcon)`
  margin-top: 2rem;
`;
